import { Injectable } from '@angular/core';
import { Guid } from 'ez-guid';
import { CardBrandTypeString } from '../models/payment-service-models.model';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  constructor() { }
  public getOrCreateIdempotencyKey(): string {
    const guid = Guid.create().toShortString();
    if (!sessionStorage.getItem('idempotency_key')) {
      sessionStorage.setItem('idempotency_key', guid);
    }
    return sessionStorage.getItem('idempotency_key');
  }
  createRange(min: number, max: number, increment: number): any {
    const items: number[] = [];
    for (let i = min; i <= max; i += increment) {
      items.push(i);
    }
    return items;
  }
  cardType(brand) {
    if (brand.toLowerCase() === CardBrandTypeString.Visa) {
      return CardBrandTypeString.Visa;
    } else if (brand.toLowerCase() === CardBrandTypeString.Mastercard) {
      return CardBrandTypeString.Mastercard;
    } else if (brand.toLowerCase() === CardBrandTypeString.Discover) {
      return CardBrandTypeString.Discover;
    } else if (brand.toLowerCase() === CardBrandTypeString.AmericanExpress || brand.toLowerCase() === CardBrandTypeString.Amex) {
      return CardBrandTypeString.Amex;
    } else if (brand.toLowerCase() === CardBrandTypeString.DinersClub || brand.toLowerCase() === CardBrandTypeString.Dinersclub
      || brand.toLowerCase() === CardBrandTypeString.Diners) {
      return CardBrandTypeString.Dinersclub;
    } else {
      return CardBrandTypeString.Generic;
    }
  }
  public static generateQueryParams(keys: string[], values: any[]) {
    const params = {};
    if(!keys.length || !values.length || keys.length !== values.length) {
      return params;
    }
    keys.forEach((key, index) => {
      params[key] = values[index];
    });    
    return params;
  } 
}
